import React from 'react';
import { useSelector } from 'react-redux';

import { configs } from '@constants/configs/configs';
import {
    selectHasSsapDataInconsistencies,
    selectSsapDataInconsistencyIssueCount,
} from '@utils/ssap/ssapDataInconsistency/ssapDataInconsistencySelectors';
import { darculaSsapDataInconsistencyBannerStyles } from '@components/hyperDashboard/darculaTheme';

const {
    bannerShellStyle,
    bannerStyle,
    bannerContentStyle,
    bannerTextBlockStyle,
    bannerHeadlineStyle,
    bannerSublineStyle,
    bannerCountBadgeStyle,
    keyframesCss,
    beaconLabel,
} = darculaSsapDataInconsistencyBannerStyles;

const InconsistencyBeacon = () => (
    <span className="ssap-inconsistency-beacon" aria-hidden title={ beaconLabel }>
        <span className="ssap-inconsistency-beacon__rotor" />
        <span className="ssap-inconsistency-beacon__ring" />
        <span className="ssap-inconsistency-beacon__ring ssap-inconsistency-beacon__ring--delayed" />
        <span className="ssap-inconsistency-beacon__ring ssap-inconsistency-beacon__ring--delayed-2" />
        <span className="ssap-inconsistency-beacon__core">!</span>
    </span>
);

const SsapDataInconsistencyBanner = () => {
    const hasIssues = useSelector(selectHasSsapDataInconsistencies);
    const issueCount = useSelector(selectSsapDataInconsistencyIssueCount);

    if (!configs.ENV.DEVELOPMENT || !hasIssues) {
        return null;
    }

    return (
        <div style={ bannerShellStyle }>
            <style>{ keyframesCss }</style>
            <div
                role="alert"
                aria-live="assertive"
                className="ssap-inconsistency-banner"
                style={ bannerStyle }
            >
                <div className="ssap-inconsistency-banner__content" style={ bannerContentStyle }>
                    <InconsistencyBeacon />
                    <div style={ bannerTextBlockStyle }>
                        <span style={ bannerHeadlineStyle }>SSAP data inconsistency detected</span>
                        <span style={ bannerSublineStyle }>
                            Open Data Inconsistencies in HyperDashboard for details
                        </span>
                    </div>
                    <span className="ssap-inconsistency-banner__count" style={ bannerCountBadgeStyle }>
                        { issueCount }
                        { ` issue${issueCount === 1 ? '' : 's'}` }
                    </span>
                </div>
            </div>
        </div>
    );
};

export default SsapDataInconsistencyBanner;
